<template>
    <div class="list_template_div">
        <group-card title="List Templates" icon="list">
            <md-dialog-alert
                :md-active.sync="alertMessage"
                md-title=" "
                :md-content="message" />
            <md-progress-spinner md-mode="indeterminate" v-if="loading"></md-progress-spinner>
            <md-list>
              <md-list-item
                v-for="template in docTemplates"
                v-bind:key="template.id"
              >
                <md-icon>arrow_right_alt</md-icon>
                <span class="md-list-item-text">
                        {{ template.display_name }}
                    </span>
                <loading-icon-text-button class="md-primary md-simple"
                                          v-if="template.has_function && template.manually_generatable"
                                          icon="check_box"
                                          @click="toggleGeneratable(template, false)">
                  Generatable
                </loading-icon-text-button>
                <loading-icon-text-button class="md-primary md-simple"
                                          v-if="template.has_function && !template.manually_generatable"
                                          icon="check_box_outline_blank"
                                          @click="toggleGeneratable(template, true)">
                  Generatable
                </loading-icon-text-button>
                <a :href="template.url" target="_blank" :disabled="template.url == null"
                   :class="{disabled: template.url == null}">
                  <md-icon class="md-primary">download</md-icon>
                </a>
                <md-icon>
                  <span class="delete-icon" @click="removeTemplate(template)">clear</span>
                </md-icon>

              </md-list-item>
            </md-list>
        </group-card>
    </div>
</template>

<script>
import { GroupCard } from "@/components";
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import LoadingIconTextButton from "../LoadingIconTextButton";
export default {
    data() {
        return {
            alertMessage: false,
            message: '',
            loading: false,
            selected_template: [],
        }
    },
    components: {
      LoadingIconTextButton,
        GroupCard,
    },
    beforeMount() {
        this.$store.dispatch('fetch_doc_templates');
    },
    computed: {
        ...mapGetters([
           "docTemplates"
        ]),
    },
    methods: {
        async toggleGeneratable(item, flag){
          item.manually_generatable = flag;
          await this.generatableTemplate();
        },
        async removeTemplate(template) {
            this.loading = true;

            const payload = {
                'doc_template_id': template.id
            }

            await this.$store.dispatch('delete_doc_template', payload)
                .then(response => {
                    this.loadmessage('the template ' + template.display_name + ' has been removed');
                })
                .catch(error => {
                    this.loadmessage('failed to remove the document tamplate');
                });
        },

        loadmessage(message) {
            this.alertMessage = true;
            this.message = message;
            this.loading = false;
        },

        async generatableTemplate() {
          let payload = {
            doc_templates: this.docTemplates,
          }

          try {
            let response = await this.$store.dispatch('generatable_template', payload);
          } catch (error) {
            console.error(error);
            this.loadmessage('failed to check generatable template');
          }
        },
    }
}
</script>

<style scoped>
.list_template_div {
    width: 49%;
    float: left;
}

.md-ripple > span {
    position: relative;
}

.delete-icon {
    cursor: pointer;
}
</style>
